import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    // tenantid: "20161026154246cef6ffa1-e1ee-4fc7-8577-27dcfc282484",  // 汉之韵正式
    // ztbTenantID: "202107131042358ae787ea-6eaf-4593-be3d-fd904fa88ca8",  // 汉之韵正式

    tenantid: "2016060614452413f946b3-3d3b-4bb9-cre6-38d177589090",  // 正式
    // tenantid: "2015080417560053a08f47-e154-4b1d-af39-17481cf1e7d2",
    ztbTenantID: "202104081322500dcf9b05-ed93-49a4-b786-404f19693a19",  // 正式
    baseImgUrl: "http://oa.haopan.net", //图片前缀地址
  },
  mutations: {
    setTenantid(state, tenantid) {
      state.tenantid = tenantid;
    },
    setztbTenantID(state, ztbTenantID) {
      state.ztbTenantID = ztbTenantID;
    },
    setbaseImgUrl(state, baseImgUrl) {
      state.baseImgUrl = baseImgUrl;
    },
  },
  actions: {
    setTenantid(context, tenantid) {
      context.commit("setTenantid", tenantid);
    },
    setztbTenantID(context, ztbTenantID) {
      context.commit("setztbTenantID", ztbTenantID);
    },
    setbaseImgUrl(context, baseImgUrl) {
      context.commit("setbaseImgUrl", baseImgUrl);
    },
  },
  getters: {},
});
export default store;
